import Alpine from 'alpinejs'

export default (() => {
  if (window.pageSettings.editmode) return

  Alpine.data('slider', function (config = {}) {
    let destroyed = false

    return {
      instance: null,
      arrowOffset: 0,
      pause() {},
      resume() {},
      destroy() {
        destroyed = true
        this.instance?.destroy()
      },
      async init() {
        try {
          const createSlider = await import('./module').then(mod => mod.default)
          if (!destroyed) createSlider(config, this)
        } catch (error) {
          console.log('Problems loading swiper')
        }
      },
    }
  })
})()
